"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFeedbackStop = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const transformToDate_1 = require("../transformers/transformToDate");
let CustomerFeedbackStop = class CustomerFeedbackStop {
    locationId;
    createdAt = new Date(); // requested at
    score;
    text;
};
exports.CustomerFeedbackStop = CustomerFeedbackStop;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomerFeedbackStop.prototype, "locationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CustomerFeedbackStop.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomerFeedbackStop.prototype, "score", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomerFeedbackStop.prototype, "text", void 0);
exports.CustomerFeedbackStop = CustomerFeedbackStop = __decorate([
    (0, type_graphql_1.ObjectType)("CustomerFeedbackStop"),
    (0, type_graphql_1.InputType)("CustomerFeedbackStopInput")
], CustomerFeedbackStop);
//# sourceMappingURL=CustomerFeedbackStop.js.map